import { useReduxState } from 'hooks';
import { useFormState } from 'informed';
import { Alert } from 'components/common';
import {
  Checkbox,
  FormGroup,
  FormSection,
  Select
} from 'components/common/form';

interface SummaryOption {
  label: string;
  value: string;
}

interface Props {
  isSiteSettingsView: boolean;
  summaryOptions: SummaryOption[];
}

const UserSummaryEmailConfiguration = ({
  isSiteSettingsView,
  summaryOptions
}: Props) => {
  const formState = useFormState();

  const { messages, serverConfig } = useReduxState();

  return (
    <FormSection>
      {serverConfig.profileSummaryEmailEnabled && !isSiteSettingsView && (
        <Alert
          style={{ marginBottom: 15 }}
          text={messages.settingsSummaryEmailSomeOptionsAreEnforced}
          type="warning-light"
        />
      )}
      <FormGroup
        label={messages.settingsSummaryEmail}
        labelHelpText={messages.settingsSummaryEmailHelpText}
      >
        <Checkbox
          disabled={
            serverConfig.profileSummaryEmailEnabled && !isSiteSettingsView
          }
          id="enable-summmary-email"
          field="profileSummaryEmailEnabled"
          label={messages.settingsSummaryEmailSubscribe}
          style={{ marginTop: 5 }}
        />
      </FormGroup>

      <FormGroup label={messages.settingsSummaryEmailFrequency}>
        <Select
          disabled={
            (serverConfig.profileSummaryEmailEnabled && !isSiteSettingsView) ||
            !formState.values.profileSummaryEmailEnabled
          }
          id="summary-email-frequency"
          field="profileSummaryEmailFrequency"
          options={[
            {
              label: messages.settingsSummaryEmailFrequencyDay,
              value: 'day'
            },
            {
              label: messages.settingsSummaryEmailFrequencyWeek,
              value: 'week'
            },
            {
              label: messages.settingsSummaryEmailFrequencyMonth,
              value: 'month'
            }
          ]}
          style={{ maxWidth: 250 }}
        />
      </FormGroup>

      <FormGroup label={messages.settingsSummaryEmailChooseEvents}>
        {summaryOptions.map((option) => (
          <Checkbox
            key={option.value}
            disabled={
              (serverConfig.profileSummaryEmailEnabled
                ? serverConfig.profileSummaryEmailOptions[option.value] &&
                  !isSiteSettingsView
                : false) || !formState.values.profileSummaryEmailEnabled
            }
            id={`summary-email-option-${option.value}`}
            field={`profileSummaryEmailOptions.${option.value}`}
            label={option.label}
            style={{ marginTop: 5 }}
          />
        ))}
      </FormGroup>
    </FormSection>
  );
};

export default UserSummaryEmailConfiguration;
